import ReactPlayer from 'react-player'
import React, { useState, useEffect, useRef } from 'react'
// import { Dialog, DialogContent } from '@mui/material'
import { useOutletContext } from 'react-router-dom'
import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'
import { castPhotos, galleryPhotos, filmFacts, hillaryPlaces } from '../data'
import { setPageMeta } from '../seo'
import Video from 'yet-another-react-lightbox/plugins/video'
import logo from '../the-girl-and-her-piano-logo.webp'
import LaurelScroller from '../components/LaurelScroller'
import HeroLaurels from '../components/HeroLaurels'
import SiteFooter from '../components/SiteFooter'
const videoUrl = '/assets/Girl-with-Piano-Trailer-no-text.mp4'
const FILM_YOUTUBE_ID = 'vSgM75wn9Mo'
const TRAILER_YOUTUBE_ID = 'sC02BQza_YU'


const ContactForm = () => {
  // const { isMobile } = useOutletContext()
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus('submitting');
    try {
      const response = await fetch('/contact.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      
      if (response.ok) {
        console.log('Form submitted successfully');
        setFormData({ name: '', email: '', message: '' });
        setSubmitStatus('success');
        setTimeout(() => setSubmitStatus(null), 5000); // Clear success message after 5 seconds
      } else {
        console.error('Form submission failed');
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="contact-form">
      <div className="form-group" style={{ justifyContent: 'space-between' }}>
        <div>
          <label htmlFor="name" className="form-label">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="form-input"
            placeholder="Enter your name"
          />
        </div>
        <div>
          <label htmlFor="email" className="form-label">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="form-input"
            placeholder="Enter your email"
          />
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="message" className="form-label">Message</label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
          className="form-textarea"
          placeholder="Enter your message"
          rows="5"
        ></textarea>
      </div>
      <button type="submit" className="submit-button" disabled={submitStatus === 'submitting'}>
        {submitStatus === 'submitting' ? 'Sending...' : 'Send Message'}
      </button>
      {submitStatus === 'success' && (
        <div className="success-message">Thank you for your message. We'll get back to you soon!</div>
      )}
      {submitStatus === 'error' && (
        <div className="error-message">An error occurred. Please try again later.</div>
      )}
    </form>
  );
};

// The facts, beside the prose on a desktop and beneath it on a phone. Pulling
// them out means the writing can be writing while a search engine, an educator
// or a festival judge still finds what they need at a glance.
const FactPanel = ({ heading, items, large }) => (
  <aside className={`fact-panel ${large ? 'fact-panel--large' : ''}`}>
    <span className='fact-panel-rule' aria-hidden='true' />
    {heading && <p className='fact-panel-heading'>{heading}</p>}
    <dl>
      {items.map((f) => (
        <div className='fact-row' key={f.label}>
          <dt>{f.label}</dt>
          <dd>{f.value}</dd>
        </div>
      ))}
    </dl>
  </aside>
)

const Trailer = ({ setShowTrailer, isMobile, isLandscape }) => {
  const [playing, setPlaying] = useState(isMobile)
  return (
    <header data-tone='dark' className={`trailer-header ${isMobile ? 'mobile' : ''} ${isLandscape ? 'landscape' : ''}`}>
      <div className='bg-vid'
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
        onMouseEnter={() => { if (!isMobile) { setPlaying(true) } }}
        onClick={() => { if (isMobile) { setShowTrailer(true) } else { setPlaying(true) } }}>
        <ReactPlayer
          config={ { file: { attributes: {
            poster: '/assets/gap/header-bg.jpg',
            // without playsInline a phone takes the video fullscreen instead
            // of playing it in place, and refuses to autoplay
            playsInline: true,
            preload: 'auto',
          } } } }
          url={videoUrl} width='100%' height='100%' style={{ position: 'absolute', top: 0, left: 0 }} playing={playing} loop muted />
      </div>
      <div className={`video-overlay ${isMobile ? 'mobile' : ''}`}>
        <div className='overlay-content'>
          <div className='flex-grid'>
            <div className='grid-item header-title'>
              <img src={logo} alt='The Girl and Her Piano' className='header-logo' width='1000' height='243' fetchpriority='high' decoding='sync'/>
            </div>
            <div className='grid-item trailer-info'>
              <div className={`horizontal-grid ${isMobile ? 'mobile' : ''}`}>
                <div className='grid-item narrator-info-grid-item'>
                  <div>
                    <button className='trailer-button' onClick={() => document.getElementById('watch')?.scrollIntoView({ behavior: 'smooth' })} style={{ pointerEvents: 'initial' }}>
                      Watch Full Film
                    </button>
                  </div>
                </div>
                <div className='grid-item'>
                </div>
              </div>
              <div className='film-details-container'>
                <h3 className='film-details'>
                  SHORT DOCUMENTARY . 11m . 2024 .{' '}
                  <button className='film-details-link' onClick={() => setShowTrailer(true)} style={{ pointerEvents: 'initial' }}>
                    WATCH THE TRAILER
                  </button>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

const PhotoWithContent = ({ slide, items, isMobile }) => {
  return (
    <div className={`photo-with-content ${isMobile ? 'mobile' : ''}`}>
      <div className='photo-with-content-grid'>
        <div className='photo-with-content-photo'>
          {slide.link ? (
            <a href={slide.link} target="_blank" rel="noopener noreferrer">
              <img src={slide.src} alt={slide.alt} />
            </a>
          ) : (
            <img src={slide.src} alt={slide.alt} />
          )}
        </div>
        <div className='photo-with-content-text'>
          <h2>{slide.title}</h2>
          <div>{slide.content}
            {slide.link && (<div className='link'><a href={slide.link}>{slide.link}</a></div>)}
          </div>
        </div>
      </div>
    </div>
  )
}

const PhotoGrid = ({ photos, renderPhoto, maxPhotos }) => {
  const [open, setOpen] = useState(false)
  const [items, setItems] = useState([])
  const [index, setIndex] = useState(-1)
  const [isHidden, setIsHidden] = useState(true)
  useEffect(() => {
    if (photos.length > 0) {
      const slides = photos.map((photo) => {
        const item = { ...photo }
        if (photo.content) {
          item.type = 'custom-slide'
        }
        return item
      })
      // console.log(slides)
      setItems(slides)
    }
  }, [photos])
  let props = {
    index,
    open,
    close: () => {
      setOpen(false)
      setIndex(-1)
    },
    slides: items,
    render: {
      slide: ({ slide }) => renderPhoto ? renderPhoto({ slide, items }) : null
    }
  }
  return (
    <>
      <div className='photo-grid'>
        {photos.map((photo, index) => {
          let className = 'photo-item-container'
          if (index > (maxPhotos - 1) && isHidden) {
            className += ' hide'
          }
          return (
            <div className={className} key={`photo-item-${index}`}>
              <div className='photo-item-wrapper'>
                <div 
                  className='photo-item'
                  onClick={() => {
                    setIndex(index)
                    setOpen(true)
                  }}
                >
                  <img src={photo.src} alt={photo.alt} loading='lazy' decoding='async' />
                </div>
              </div>
              <div className='photo-item-text'>
                {photo.title && <div className='photo-item-title'>{photo.title}</div>}
                {photo.subtitle && <div className='photo-item-subtitle'>{photo.subtitle}</div>}
              </div>
            </div>
          )
        })}
      </div>
      {maxPhotos && maxPhotos > 0 && <div className='show-more' onClick={() => setIsHidden(!isHidden)}>Show {isHidden ? 'More' : 'Less'}</div>}
      <Lightbox
        {...props}
      />
    </>
  )
}

// const DisplayPhoto = ({ photo }) => {
//   return (
//     <div className='display-photo-section' style={{
//       backgroundImage: `url(${photo.url || ''})`
//     }}>
//       <div className='overlay'></div>
//       { photo.alt && <h2 className='overlay-text'>{photo.alt}</h2> }
//     </div>
//   )
// }

const FullWidthQuote = ({ quote }) => {
  return (
    <div className='full-width-section full-width-quote' data-tone='dark'>
      <div className='full-width-quote-text'>{quote}</div>
    </div>
  )
}

// The quote used to be burned into the photograph, which meant a search engine
// could not read it, a screen reader could not speak it, and nobody could quote
// it. It is live text now, over a clean photograph.
//
// The reason it was flattened two years ago was that the words overflowed a
// short image on a narrow screen. The block is a fixed aspect ratio here rather
// than an image at its natural height, so the text has somewhere to sit however
// narrow the screen gets, and a gradient keeps it legible over a bright frame.
const FullWidthDisplayPhoto = ({ photo, isMobile }) => {
  const src = isMobile && photo.mobileUrl ? photo.mobileUrl : photo.url
  return (
    <figure className={`full-width-photo ${photo.focus ? 'focus-' + photo.focus : ''}`} style={{ backgroundImage: `url(${src})` }}>
      <img className='visually-hidden' src={src} alt={photo.alt} />
      {photo.quote && (
        <figcaption className='full-width-caption'>
          <div className='content-container'>
            <span className='full-width-rule' aria-hidden='true' />
            <blockquote className={(Array.isArray(photo.quote) ? photo.quote.join(' ') : photo.quote).length > 200 ? 'is-long' : ''}>
              {Array.isArray(photo.quote)
                ? photo.quote.map((part, i) => (
                    <span key={part} className={i === 0 ? 'quote-lead' : ''}>{part}</span>
                  ))
                : photo.quote}
            </blockquote>
            {photo.attribution && <cite>{photo.attribution}</cite>}
          </div>
        </figcaption>
      )}
    </figure>
  )
}

const FilmPlayer = () => {
  const [playing, setPlaying] = useState(false)
  const frameRef = useRef(null)

  // Pause the film when the menu covers the page.
  useEffect(() => {
    const pause = () => {
      const frame = frameRef.current
      if (!frame || !frame.contentWindow) return
      frame.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }),
        '*'
      )
    }
    window.addEventListener('menu:open', pause)
    return () => window.removeEventListener('menu:open', pause)
  }, [])

  if (playing) {
    return (
      <div className='film-player'>
        <iframe
          ref={frameRef}
          src={`https://www.youtube.com/embed/${FILM_YOUTUBE_ID}?autoplay=1&rel=0&enablejsapi=1`}
          title='The Girl and Her Piano - Full Documentary'
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen'
          allowFullScreen
        />
      </div>
    )
  }

  return (
    <button
      className='film-player film-player--facade'
      onClick={() => setPlaying(true)}
      aria-label='Play the full film'
    >
      <img
        src='/assets/gap/the-girl-and-her-piano-landscape-youtube-still-website-s.jpg'
        alt='The Girl and Her Piano'
      />
      <span className='film-player-play' aria-hidden='true'>
        <svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
          <circle cx='50' cy='50' r='48' fill='none' stroke='currentColor' strokeWidth='2' />
          <path d='M40 32 L72 50 L40 68 Z' fill='currentColor' />
        </svg>
      </span>
    </button>
  )
}

const Main = () => {
  const { isMobile, isLandscape, isMobileDevice } = useOutletContext()
  const [showTrailer, setShowTrailer] = useState(false)
  const [showMoreTextAboutHillary, setShowMoreTextAboutHillary] = useState(true)
  const [showMoreTextAboutFilm, setShowMoreTextAboutFilm] = useState(true)
  useEffect(() => {
    const collapse = isMobileDevice || isMobile
    setShowMoreTextAboutFilm(!collapse);
    setShowMoreTextAboutHillary(!collapse);
  }, [isMobileDevice, isMobile]);

  useEffect(() => {
    setPageMeta({
      title: 'The Girl and Her Piano | A Pianist\u2019s Journey to Bhutan\u2019s Highlands',
      path: '/',
      description: 'At 4,000 metres in the Bhutanese Himalaya, a twelve-year-old pianist played for a country whose glaciers are melting. An eleven-minute documentary directed by Elaine Lim, free to watch.',
    })
  }, [])

  // Arriving from another page with a hash (/#contact, /#watch): the browser
  // looks for the target before React has rendered it, so scroll once mounted.
  useEffect(() => {
    const hash = window.location.hash
    if (!hash) return undefined
    const id = hash.slice(1)
    const timer = window.setTimeout(() => {
      const target = document.getElementById(id)
      if (target) target.scrollIntoView({ behavior: 'smooth' })
    }, 300)
    return () => window.clearTimeout(timer)
  }, []);

  return (
    <>
      <div className='App'>
        {/* The page needs a single h1 saying what it is. The hero carries the
            title as artwork, which a search engine cannot read, and the slider
            was emitting an h1 per slide. */}
        <h1 className='visually-hidden'>
          The Girl and Her Piano, a short documentary from Bhutan
        </h1>
        <Trailer setShowTrailer={setShowTrailer} isMobile={isMobile} isLandscape={isLandscape} />
        <HeroLaurels />
        <div className='content'>
          <main>
            <FullWidthQuote quote='Transcends borders and inspires action and hope towards climate sustainability for future generations' />
            {/* Eighteen laurels, one row, arrows either side. This is the most
                visible place on the site and the band behind it is already blue,
                which is what the white-on-transparent files need. */}
            <LaurelScroller />
            <section id='watch'>
              <div className='content-container'>
                <h2>Watch the film</h2>
                <FilmPlayer />
              </div>
            </section>
            <section id='about'>
              <div className='content-container'>
                <div className='with-facts'>
                  <div className='with-facts-text'>
                    <h2>A piano at 4,000 metres in Bhutan</h2>
                    <p>High in the remote highlands of Bhutan, 12-year-old pianist Hillary O’Sullivan travelled with a piano and a message. The Girl and Her Piano follows her to 4,000 metres above sea level, where she performed in the presence of the King of Bhutan.</p>
                    <p>She played surrounded by highland people who live with the effects of global warming daily, stirred by a desire to keep speaking through music for places that cannot speak for themselves.</p>
                    {showMoreTextAboutFilm && (<>
                    <p>Directed by Elaine Lim in her filmmaking debut, the film is eleven minutes long and free to watch. As Hillary’s notes carry across the mountains, her narration reflects the clarity of a generation that refuses to wait.</p>
                    <p>She was the first foreigner and the youngest performer invited to the Royal Highland Festival since it began in 2016. Bhutan is the world’s first declared carbon-negative nation. It is also losing its glaciers.</p>
                    <p className='pull-quote'>“Himalayan glaciers could lose up to 80% of their ice by the year 2100 due to global warming,” Hillary says in the narration. “As part of the younger generation, I sometimes feel small compared to the huge problem we are facing.”</p></>)}
                  </div>
                  <FactPanel items={filmFacts} />
                </div>
                {(isMobile || isMobileDevice) && <div className='show-more' onClick={() => setShowMoreTextAboutFilm(!showMoreTextAboutFilm)}>Show {showMoreTextAboutFilm ? 'Less' : 'More'}</div>}
              </div>
            </section>
            <FullWidthDisplayPhoto
              isMobile={isMobile}
              photo={{
              url: '/assets/gap/the-girl-and-her-piano-hillary-osullivan-royal-highland-festival-wide.jpg',
              alt: 'Hillary O’Sullivan playing at the Royal Highland Festival in Laya, Bhutan',
              focus: 'right',
              quote: [
                '“HILLARY CAPTIVATED the audience with her powerful message of climate change action.',
                'This is poignantly captured in The Girl and Her Piano, a documentary which amplifies awareness for our climate through the art of music. The Girl and Her Piano transcends borders and inspires action and hope towards climate sustainability for future generations.”',
              ],
              attribution: 'Bhutan Royal Highland Festival'
            }} />
            <section id='about-hillary'>
              <div className='content-container'>
                <div className='with-facts'>
                  <div className='with-facts-text'>
                    <h2>Hillary O’Sullivan, pianist and climate ambassador</h2>
                <p>Hillary O’Sullivan is a Singaporean pianist who uses her music to argue for the climate. She is the subject of The Girl and Her Piano.</p>
                <p>She began playing at three. She has given solo recitals on remote islands in Indonesia and the Maldives, to villagers and their children, and in 2018 made a photo-documentary, “Above the Sands”, on the people of Bunaken, interviewing and photographing them to understand their lives.</p>
                {showMoreTextAboutHillary && (
                  <>
                  <p>At eleven she travelled to Antarctica as the youngest Key Opinion Ambassador of the Antarctic Climate Expedition, performing ‘Rhapsody of a Changing Antarctic’, written for the expedition by Belgian composer Eric Bettens.</p>
                  <p>Later that year came Bhutan, and the Royal Highland Festival in Laya: the first foreigner and youngest performer invited since the festival began in 2016. His Majesty The King envisioned the festival to preserve and celebrate Bhutan’s highland culture while promoting the country’s work on climate resilience.</p>
                  <p>In the summer of 2025 she returned to the ice as a climate ambassador, this time in the high Arctic, on an expedition hosted by Dr Sylvia Earle, who had also been aboard in Antarctica. At 82 degrees north, on moving pack ice, she played a grand piano. The Arctic is warming faster than anywhere on Earth, and the poles hold the ice the rest of us depend on.</p>
                  <p className='pull-quote'>She has now performed at both poles and at 4,000 metres in the Himalaya. Her next journey takes her to Sumatra, to highlight what is happening to one of the last great rainforests and the lives that depend on it.</p>
                  </>
                )}
                  </div>
                  <FactPanel heading='She has played at' items={hillaryPlaces} large />
                </div>
                {(isMobile || isMobileDevice) && <div className='show-more' onClick={() => setShowMoreTextAboutHillary(!showMoreTextAboutHillary)}>Show {showMoreTextAboutHillary ? 'Less' : 'More'}</div>}
              </div>
            </section>
            <FullWidthDisplayPhoto
              isMobile={isMobile}
              photo={{
              url: '/assets/gap/layap-girls-walking-royal-highland-festival-laya.jpg',
              alt: 'Girls of Laya walking together at the Royal Highland Festival, Bhutan',
              quote: '“I DREAM of a world where children like myself can continue to embrace their lives in safety.”',
              attribution: 'Hillary O’Sullivan',
            }} />
            <section id='gallery'>
              <div className='content-container'>
                <h2>Photographs from Laya, Bhutan</h2>
                <PhotoGrid photos={galleryPhotos} maxPhotos={9} isMobile={isMobile} />
              </div>
            </section>
            <FullWidthDisplayPhoto
              isMobile={isMobile}
              photo={{
              url: '/assets/gap/laya-bhutan-himalaya-farmhouse-glacier.jpg',
              alt: 'A farmhouse on the slope above Laya, Bhutan, with a glacier in the valley beyond',
              quote: '“CLIMATE CHANGE, something I have witnessed in the Antarctic, is not just a distant problem far away. It is also happening here in Bhutan and the Himalayas.”',
              attribution: 'Hillary O’Sullivan',
            }} />
            <section id='cast'>
              <div className='content-container'>
                <h2>Cast, Crew and Partners</h2>
                <PhotoGrid photos={castPhotos}
                isMobile={isMobile}
                renderPhoto={({ slide, items }) => (
                  <PhotoWithContent slide={slide} items={castPhotos} isMobile={isMobile} />
                )} />
              </div>
            </section>
            <section id='where' className='map-section'>
              <img className='bhutan-map' width='1317' height='946' loading='lazy' decoding='async' src='/assets/gap/map-of-bhutan-laya-gasa.jpg'
                   alt='Map of Bhutan showing Laya in the far north of Gasa district, in the snow along the Tibetan border' />
            </section>

            <section id='contact'>
              <div className='content-container'>
                <h2>Contact</h2>
                <ContactForm />
                {/* the same four links as Hillary's page, same style */}
                <p className='hillary-contact-links'>
                  <a href='mailto:info@thegirlandherpiano.com'>Email</a>
                  <a href='https://www.instagram.com/thegirlandherpiano' target='_blank' rel='noopener noreferrer'>Instagram</a>
                  <a href='https://www.facebook.com/thegirlandherpiano' target='_blank' rel='noopener noreferrer'>Facebook</a>
                  <a href='https://www.youtube.com/@hillaryosullivan' target='_blank' rel='noopener noreferrer'>YouTube</a>
                </p>
              </div>
            </section>
          </main>
        </div>
        <SiteFooter />
      </div>
      {showTrailer && (
        <div className='trailer-modal' onClick={() => setShowTrailer(false)}>
          <button className='trailer-modal-close' onClick={() => setShowTrailer(false)} aria-label='Close trailer'>&times;</button>
          <div className='trailer-modal-inner' onClick={(e) => e.stopPropagation()}>
            <div className='video-embed'>
              <iframe
                src={`https://www.youtube.com/embed/${TRAILER_YOUTUBE_ID}?autoplay=1&rel=0`}
                title='The Girl and Her Piano - Trailer'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen'
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Main